export const sampleCaptionData = {
  "skeleton": [
    {
      "id": "s1",
      "words": ["w1", "w2", "w3", "w4"],
      "start_time": 0,
      "end_time": 3,
      "size": "medium",
      "positionY": null,
      "emphasize": false,
      "disabled": false
    },
    {
      "id": "s2",
      "words": ["w5", "w6", "w7", "w8"],
      "start_time": 3,
      "end_time": 6,
      "size": "medium",
      "positionY": null,
      "emphasize": false,
      "disabled": false
    }
  ],
  "words": [
    {
      "id": "w1",
      "text": "حيث",
      "arabizi": "7aytho",
      "type": "word",
      "start_time": 0,
      "end_time": 0.75,
      "highlightColor": null,
      "break": false
    },
    {
      "id": "w2",
      "text": "الشركه",
      "arabizi": "elsharka",
      "type": "word",
      "start_time": 0.75,
      "end_time": 1.5,
      "highlightColor": null,
      "break": true
    },
    {
      "id": "w3",
      "text": "تتمتع",
      "arabizi": "tetamatta3",
      "type": "word",
      "start_time": 1.5,
      "end_time": 2.25,
      "highlightColor": null,
      "break": false
    },
    {
      "id": "w4",
      "text": "بالشخصية",
      "arabizi": "belshakhseyya",
      "type": "word",
      "start_time": 2.25,
      "end_time": 3,
      "highlightColor": null,
      "break": false
    },
    {
      "id": "w5",
      "text": "والثقة",
      "arabizi": "welthiqa",
      "type": "word",
      "start_time": 3,
      "end_time": 3.75,
      "highlightColor": null,
      "break": false
    },
    {
      "id": "w6",
      "text": "والاحترافية",
      "arabizi": "weli7tirafeyya",
      "type": "word",
      "start_time": 3.75,
      "end_time": 4.5,
      "highlightColor": null,
      "break": true
    },
    {
      "id": "w7",
      "text": "في",
      "arabizi": "fi",
      "type": "word",
      "start_time": 4.5,
      "end_time": 5.25,
      "highlightColor": null,
      "break": false
    },
    {
      "id": "w8",
      "text": "كل",
      "arabizi": "kol",
      "type": "word",
      "start_time": 5.25,
      "end_time": 6,
      "highlightColor": null,
      "break": false
    }
  ],
  "phrases": []
};
